import React from 'react';
import KickImage from 'Reuseables/KickImage';

import { ITitleContainerProps } from './TitleContainer.definitions';

/** CSS import */
import Styles from './TitleContainer.module.scss';
import { useHistory } from 'react-router';

const TitleContainer: React.FC<ITitleContainerProps> =
  ({}: ITitleContainerProps) => {
    const history = useHistory();
    return (
      <div
        className={Styles['blog-title-container']}
        onClick={() => history.replace('/kickavenews')}
      >
        <p className={Styles['blog-title'] + ' ' + Styles['bold']}>KICKAVE</p>
        <p className={Styles['blog-title']}>NEWS</p>
      </div>
    );
  };

export default TitleContainer;
